import React from 'react';
interface ProductIdentifierSectionProps {
  productName: string;
  language: string;
}

const ProductIdentifierSection: React.FC<ProductIdentifierSectionProps> = ({
  productName,
  language,
}) => {
  return (
    <div>
      <h2>Product Identifier</h2>

      <label htmlFor="productName">Product name *</label>
      <input
        type="text"
        id="productName"
        value={productName}
        required
      />
      <label htmlFor="language-code">Language code *</label>
      <input
        type="text"
        id="language-code"
        value={language}
        required
      />
    </div>
  );
};

export default ProductIdentifierSection;
